<template>
    <!-- User Profile Personal Basic Info Tab Content View From Account Profile -->
    <div>
        <div class="tabs-content-secondblock">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ml-2 mr-1 mb-3">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="infoHeader py-6 px-4">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <a class="top-tabs-reminders d-flex align-items-center justify-content-center fw-600"
                                            role="tab" aria-controls="basictab" aria-expanded="true"
                                            aria-selected="false" :class="{ active: toView === 'birthdayView'}"
                                            @click="changeView('birthdayView')">
                                            <span>Birthdays</span>
                                        </a>
                                        <a class="top-tabs-reminders d-flex align-items-center justify-content-center fw-600 mx-20"
                                            role="tab" aria-controls="basictab" aria-expanded="true"
                                            aria-selected="false" :class="{ active: toView === 'eventsView'}"
                                            @click="changeView('eventsView')">
                                            <span>Events</span>
                                        </a>
                                        <a class="top-tabs-reminders d-flex align-items-center justify-content-center fw-600"
                                            role="tab" aria-controls="basictab" aria-expanded="true"
                                            aria-selected="false" :class="{ active: toView === 'digiappsView'}"
                                            @click="changeView('digiappsView')">
                                            <span>Digi Apps</span>
                                        </a>
                                    </div>
                                    <div class="row mt-10" v-if="toView === 'birthdayView'">
                                        <div class="d-flex align-items-center justify-content-center w-100"
                                            v-if="ajaxCallinprogress">
                                            <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center w-100"
                                            v-if="!birthday_data.length && !ajaxCallinprogress">
                                            <span v-if="!adding_birthday" class="fw-600 fs-18">No Birthdays Found!</span>
                                        </div>
                                        <!-- <div @scroll="infiniteScrollBirthdays" style="overflow-x: hidden; height: 300px; width: 100%;"> -->
                                        <div style="overflow-x: hidden; height: 300px; width: 100%;">
                                            <div v-if="$route.params.id == loggedInUser.user_id" class="row">
                                                <div class="col-12" style="align-items:flex-end">
                                                    <span style="float:right;">
                                                        <button v-if="birthday_data.length > 0" style="border-radius: 18px !important;" class="btn btn-danger pointer"
                                                            @click="DeleteAll">- Delete All</button>
                                                            <button class="btn btn-secondary pointer ml-3" style="border-radius: 5px !important;" @click="addBirthday"
                                                            :disabled="add_birthdays.length == 1">+ Add Birthday</button>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6 my-4" v-for="(data,index) in birthday_data" :key="index">
                                                    <div v-if="edit_birthday && edit_birthday_index == index" class="dataTab1 d-flex">
                                                        <div class="my-5"
                                                            style="margin-top:4rem !important;margin-left:15px;">
                                                            <img :src="edit_birthday_data.profile_pic.length ? edit_birthday_data.profile_pic : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                                                style="width: 6em; border-radius: 40px; height: 6em;" />
                                                            <el-dropdown trigger="click"
                                                                style="position: absolute; margin-top: 42px; margin-left: -18px; width: 14px;">
                                                                <span class="el-dropdown-link">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/pic-options-icon.svg"
                                                                        style="height: 12px;" />
                                                                </span>
                                                                <el-dropdown-menu slot="dropdown"
                                                                    style="border-radius: 0 !important">
                                                                    <el-dropdown-item class="mx-1"
                                                                        style="box-shadow: 0 0.5px rgba(0, 0, 0, 0.33)">
                                                                        <span
                                                                            @click="deletePic">
                                                                            <img class="mr-2"
                                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash-red.svg"
                                                                                style="height: 12px;" />
                                                                            Remove Photo
                                                                        </span>
                                                                    </el-dropdown-item>
                                                                    <el-dropdown-item class="mx-1">
                                                                        <label class="pointer">
                                                                            <input type="file"
                                                                                accept="image/x-png, image/gif, image/jpeg" @change="uploadAttachment" />
                                                                            <img class="mr-2"
                                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/gallery-icon.svg"
                                                                                style="height: 12px;" />
                                                                            Upload from Gallery
                                                                        </label>
                                                                    </el-dropdown-item>
                                                                </el-dropdown-menu>
                                                            </el-dropdown>
                                                        </div>
                                                        <div class="d-flex flex-column w-100" style="margin:0 15px 15px 15px;">
                                                            <label for="name"
                                                                style="text-align:left;font-weight:600;margin-top:20px;margin-bottom:0px;">Enter
                                                                Name<span class="text-danger">*</span></label>
                                                            <input type="text" v-model="edit_birthday_data.name" v-validate="'required'" class="inputField1"
                                                                style="border-radius:5px;padding-left:10px;" name="edit_name"
                                                                placeholder="Enter Name">
                                                            <span class="invalid-feedback-form font-weight-bold" style="margin-top: 4px !important;color: #ff3b3b;line-height: 2;" v-show="errors.has('edit_name')">{{ errors.first("edit_name") }}</span>
                                                            <label for="date_of_birth"
                                                                style="text-align:left;font-weight:600;margin-bottom:0px;">Birth
                                                                Date<span class="text-danger">*</span></label>
                                                            <div style="position: relative;">
                                                                <date-picker v-model="edit_birthday_data.date_of_birth"
                                                                    :first-day-of-week="7" :not-after="new Date()"
                                                                    name="date_of_birth"
                                                                    v-validate="'required'"
                                                                    class="calendarYear mx-left calendar-edit-per inputField1"
                                                                    placeholder='DD/MM/YYYY' style="padding-left:10px;"
                                                                    value-type="format"
                                                                    format="YYYY-MM-DD" lang="en" :clearable="false"
                                                                    :editable="false" confirm confirm-text="APPLY">
                                                                </date-picker>
                                                                <span class="invalid-feedback-form font-weight-bold" style="margin-top: 4px !important;color: #ff3b3b;line-height: 2;" v-show="errors.has('date_of_birth')">{{ errors.first("date_of_birth") }}</span>
                                                            </div>
                                                            <label for="relationship"
                                                                style="text-align:left;font-weight:600;margin-bottom:0px;">Relation</label>
                                                            <div class="d-flex align-items-center">
                                                                <multiselect :max-height="200"
                                                                    class="digi-multiselect loaderbg inputField1"
                                                                    v-model="edit_birthday_data.relationship" name="relationship"
                                                                    :options="relationship_options" :searchable="true"
                                                                    @open="dropdownsData('relationship')"
                                                                    :loading="dropdown_loading"
                                                                    :close-on-select="true" :show-labels="false"
                                                                    placeholder='Select Relationship'>
                                                                    <template slot="noOptions">
                                                                        <div class="text-secondary text-center fw-600">List
                                                                            is
                                                                            Empty</div>
                                                                    </template>
                                                                    <template slot="noResult">
                                                                        <div class="text-secondary text-center fw-600">No
                                                                            Results Found</div>
                                                                    </template>
                                                                    <template slot="afterList">
                                                                        <div class="add-vendor p-2 pointer fw-500">
                                                                            Add New Relation <span class="text-secondary fw-500">'{{"-"}}'</span>
                                                                            <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                                        </div>
                                                                    </template>
                                                                </multiselect>
                                                                <span class="pointer" @click="goToSettings">
                                                                    <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2" style="width:20px" alt="">
                                                                    </el-tooltip>
                                                                </span>
                                                            </div>
                                                            <div style="align-self:flex-end">
                                                                <button class="btn btn-outline-secondary"
                                                                    style="margin-top:15px;width:50px;margin-right:10px; border-radius: 8px !important;"
                                                                    @click="closeEditDialogBox">Cancel</button>
                                                                <button class="btn btn-secondary"
                                                                    style="margin-top:15px;width:50px; border-radius: 8px !important;"
                                                                    @click="editBirthdaySubmit()">Apply</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else class="dataTab d-flex flex-row py-4">
                                                        <div class="mx-3" style="margin-top:10px;">
                                                            <img :src="data.profile_pic.length ? data.profile_pic : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                                                style="width: 6em; border-radius: 40px; height: 6em;" />
                                                        </div>
                                                        <div class="d-flex flex-column mx-3 w-100" style="overflow: hidden;">
                                                            <el-tooltip class="item" effect="dark" :content="data.name"
                                                                placement="top">
                                                                <span
                                                                    style="line-height: 20px; font-size: 15px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-top:5px;">
                                                                    {{ data.name }}</span>
                                                            </el-tooltip>
                                                            <span
                                                                style="line-height: 20px; font-size: 13px; margin-top:5px;">{{ data.date_of_birth }}</span>
                                                            <span
                                                                style="line-height: 20px; font-size: 10px; margin-top:5px;">{{ data.relationship }}</span>
                                                        </div>
                                                        <div v-if="$route.params.id == loggedInUser.user_id" class="d-flex mx-2" >
                                                            <button style="background-color:white;height:40px"
                                                                @click="editBirthday(data, index)"
                                                                :disabled="edit_birthdays.length == 1"><i
                                                                    class="icon icon-pencil text-blue pointer editIcon"></i></button>
                                                            <span @click="deleteBirthdayById(data.id)"><i
                                                                    class="icon icon-delete text-blue pointer deleteIcon"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="row" v-if="edit_birthday">
                                                <div class="col-6" >

                                                </div>
                                            </div> -->

                                            <div class="row" v-if="add_new_birthday">
                                                <div class="col-6" >
                                                    <div class="dataTab1 d-flex">
                                                        <div class="my-5"
                                                            style="margin-top:4rem !important;margin-left:15px;">
                                                            <img :src="create_birthday.profile_pic ? create_birthday.profile_pic : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                                                style="width: 6em; border-radius: 40px; height: 6em;" />
                                                            <el-dropdown trigger="click"
                                                                style="position: absolute; margin-top: 42px; margin-left: -18px; width: 14px;">
                                                                <span class="el-dropdown-link">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/pic-options-icon.svg"
                                                                        style="height: 12px;" />
                                                                </span>
                                                                <el-dropdown-menu slot="dropdown"
                                                                    style="border-radius: 0 !important">
                                                                    <el-dropdown-item class="mx-1"
                                                                        style="box-shadow: 0 0.5px rgba(0, 0, 0, 0.33)">
                                                                        <span
                                                                            @click="deletePic">
                                                                            <img class="mr-2"
                                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash-red.svg"
                                                                                style="height: 12px;" />
                                                                            Remove Photo
                                                                        </span>
                                                                    </el-dropdown-item>
                                                                    <el-dropdown-item class="mx-1">
                                                                        <label class="pointer">
                                                                            <input type="file"
                                                                                accept="image/x-png, image/gif, image/jpeg" @change="uploadAttachment" />
                                                                            <img class="mr-2"
                                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/gallery-icon.svg"
                                                                                style="height: 12px;" />
                                                                            Upload from Gallery
                                                                        </label>
                                                                    </el-dropdown-item>
                                                                </el-dropdown-menu>
                                                            </el-dropdown>
                                                        </div>
                                                        <div class="d-flex flex-column w-100" style="margin:0 15px 15px 15px;">
                                                            <label for="name"
                                                                style="text-align:left;font-weight:600;margin-top:20px;margin-bottom:0px;">Enter
                                                                Name <span class="text-danger">*</span></label>
                                                            <input type="text" v-model="create_birthday.name" v-validate="'required'" class="inputField1"
                                                                style="border-radius:5px;padding-left:10px;" name="add_name"
                                                                placeholder="Enter Name">
                                                            <span class="invalid-feedback-form font-weight-bold" style="margin-top: 4px !important;color: #ff3b3b;line-height: 2;" v-show="errors.has('add_name')">{{ errors.first("add_name") }}</span>
                                                            <label for="date_of_birth"
                                                                style="text-align:left;font-weight:600;margin-bottom:0px;">Birth
                                                                Date<span class="text-danger">*</span></label>
                                                            <date-picker v-model="create_birthday.date_of_birth"
                                                                :first-day-of-week="7" :not-after="new Date()"
                                                                name="date_of_birth"
                                                                value-type="format"
                                                                v-validate="'required'"
                                                                class="calendarYear mx-left calendar-edit-per inputField1"
                                                                placeholder='DD/MM/YYYY' style="padding-left:10px;"
                                                                format="YYYY-MM-DD" lang="en" :clearable="false"
                                                                :editable="false" confirm confirm-text="APPLY">
                                                            </date-picker>
                                                            <span class="invalid-feedback-form font-weight-bold" style="margin-top: 4px !important;color: #ff3b3b;line-height: 2;" v-show="errors.has('date_of_birth')">{{ errors.first("date_of_birth") }}</span>
                                                            <label for="relationship"
                                                                style="text-align:left;font-weight:600;margin-bottom:0px;">Relation</label>
                                                            <div class="d-flex align-items-center">
                                                                <multiselect :max-height="200"
                                                                    class="digi-multiselect loaderbg inputField1"
                                                                    v-model="create_birthday.relationship" name="relationship"
                                                                    :options="relationship_options" :searchable="true"
                                                                    :loading="dropdown_loading"
                                                                    @open="dropdownsData('relationship')"
                                                                    :close-on-select="true" :show-labels="false"
                                                                    placeholder='Select Relationship'>
                                                                    <template slot="noOptions">
                                                                        <div class="text-secondary text-center fw-600">List
                                                                            is
                                                                            Empty</div>
                                                                    </template>
                                                                    <template slot="noResult">
                                                                        <div class="text-secondary text-center fw-600">No
                                                                            Results Found</div>
                                                                    </template>
                                                                    <template slot="afterList">
                                                                        <div class="add-vendor p-2 pointer fw-500">
                                                                            Add New Relation <span class="text-secondary fw-500">'{{"-"}}'</span>
                                                                            <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                                        </div>
                                                                    </template>
                                                                </multiselect>
                                                                <span class="pointer" @click="goToSettings">
                                                                    <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="top">
                                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2" style="width:20px" alt="">
                                                                    </el-tooltip>
                                                                </span>
                                                            </div>
                                                            <div style="align-self:flex-end">
                                                                <button class="btn btn-outline-secondary"
                                                                    style="margin-top:15px;width:50px;margin-right:10px;border-radius: 8px !important;"
                                                                    @click="closeAddDialogBox">Cancel</button>
                                                                <button class="btn btn-secondary"
                                                                    style="margin-top:15px;width:50px;border-radius: 8px !important;"
                                                                    @click="submitNewBirthday()">Save</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-5 mb-5 text-center w-100" v-if="loading_scroll_birthdays"
                                            id="spinner_birthdays">
                                            <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                    </div>
                                    <div class="row mt-10" v-if="toView === 'eventsView'">
                                        <div class="col-12 d-flex justify-content-between align-items-center">
                                            <span style="color: #005dae; font-weight: 600; font-size: 18px;">{{selectedDate}}</span>
                                            <!-- <span style="color: #005dae; font-weight: 600; font-size: 18px;">This Week Events</span> -->
                                            <div class="d-flex align-items-center">
                                                <date-picker v-if="pickDate" v-model="dateRange" type="datetime"
                                                    :first-day-of-week="7" data-vv-scope="profile_data"
                                                    data-vv-as="Date Of Birth" name="date_of_birth"
                                                    class="calendarYear mx-left no-icon with-shortcuts mr-6"
                                                    format="DD-MM-YYYY HH:MM A" lang="en" :clearable="false"
                                                    :editable="false" :minute-step="1"
                                                    :popup-style="{ top: '100%', right: 0 }"
                                                    :shortcuts="datePickShortcuts" confirm range confirm-text="APPLY"
                                                    @confirm="getEventsFiltered" style="width: 23.5em !important;">
                                                </date-picker>
                                                <button class="mr-6" @click="pickDate = !pickDate"
                                                    style="background: transparent; cursor: pointer;">
                                                    <img
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/calendar-setting-default-blue.svg" />
                                                </button>
                                                <button type="button"
                                                    class="btn btn-new-primary btn-smm d-flex align-items-center float-right mr-2"
                                                    style="box-shadow: none;" @click="resetDate"><img
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon.svg"
                                                        style="width: 10px; height: 10px; margin-right: 6px;" />
                                                    Reset</button>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center w-100 mt-5"
                                            v-if="ajaxCallinprogress">
                                            <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                        <!-- <div class="d-flex align-items-center justify-content-center w-100"
                                            v-if="!ajaxCallinprogress && !event_data[Object.keys(event_data)[0]].length ">
                                            <span class="fw-600 fs-18">No Events Found!</span>
                                        </div> -->
                                        <div v-else class="w-100 px-3">
                                            <div v-if="event_data.year">
                                                <div v-if="event_data.this_month_events.length > 0">
                                                    <div class="mt-6 mb-4">
                                                        <span style="font-weight: 600; font-size: 14px;">This Month Events</span>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-6 my-4" v-for="(data,index) in event_data.this_month_events"
                                                            :key="index">
                                                            <div class="dataTab d-flex flex-row align-items-center">
                                                                <div class="d-flex flex-column justify-content-center text-center px-3"
                                                                    style="height: 100%; border-right: 1px solid #cdd2da;">
                                                                    <div class="d-flex flex-column" style="width: 70px;">
                                                                        <span
                                                                            class="blueCalendarTop">{{moment(data.start_date).format('MMM') || "-" }}</span>
                                                                        <span
                                                                            class="blueCalendarBottom">{{moment(data.start_date).format('DD') || "-"}}</span>
                                                                    </div>
                                                                    <span class="mt-5 mb-1"
                                                                        style="color: #0d5be6; font-size: 14px; line-height: 14px;">{{moment(data.start_date).format('LLLL').split(',')[0] || "-"}}</span>
                                                                    <span
                                                                        style="color: #0d5be6; font-size: 10px; line-height: 10px;">{{data.start_time || "-"}}
                                                                        {{data.ampm}}</span>
                                                                </div>
                                                                <div class="d-flex flex-column mx-3 w-100" style="overflow: hidden;">
                                                                    <div class="d-flex align-items-center" style="justify-content: space-between">
                                                                        <el-tooltip class="item" effect="dark" :content="data.event_name"
                                                                            placement="top">
                                                                            <div class=""
                                                                                style="line-height: 20px; font-size: 15px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ data.event_name }}</div>
                                                                        </el-tooltip>
                                                                        <div v-if="$route.params.id == loggedInUser.user_id" class="d-flex align-items-center ml-auto">
                                                                            <i class="icon icon-delete text-blue pointer deleteIcon" style="font-size: 1.8rem;" @click="removeEvent('deleteEvent',data)"></i>
                                                                            <i class="icon icon-pencil text-blue pointer editIcon" @click="editEventById(data)" style="font-size: 1.8rem;"></i>
                                                                        </div>
                                                                    </div>
                                                                    <span class="mt-1"
                                                                        style="line-height: 20px; font-size: 13px;">{{ data.event_type }}</span>
                                                                    <el-dropdown trigger="click" :hide-on-click="true"
                                                                        style="width: 10em;">
                                                                        <span>
                                                                            <div class="d-flex align-items-center mt-1"
                                                                                style="line-height: 15px;">
                                                                                <div v-for="(item,index) in data.invitees"
                                                                                    :key="index">
                                                                                    <span v-if="index <= 2">
                                                                                        <img style="width: 15px;"
                                                                                            :src="item.profile_pic" />
                                                                                    </span>
                                                                                    <span v-if="index == 3"
                                                                                        style="line-height: 20px; font-size: 13px;">+{{data.invitees.length - 3}}</span>
                                                                                    <span v-else></span>
                                                                                </div>
                                                                            </div>
                                                                        </span>
                                                                        <el-dropdown-menu slot="dropdown"
                                                                            style="max-height: 10em; overflow-y: auto; border-radius: 0 !important; width: 12em;">
                                                                            <el-dropdown-item
                                                                                v-for="(item,index) in data.invitees"
                                                                                :key="index"
                                                                                class="d-flex align-items-center px-2">
                                                                                <img class="mr-2" style="width: 15px;"
                                                                                    :src="item.profile_pic" />{{item.full_name || "-"}}
                                                                            </el-dropdown-item>
                                                                        </el-dropdown-menu>
                                                                    </el-dropdown>
                                                                    <div class="d-flex">
                                                                        <span class="mt-1"
                                                                            style="line-height: 20px; font-size: 13px; width: 8em;">Remind
                                                                            Before : </span>
                                                                        <div class="d-flex flex-wrap">
                                                                            <span v-for="(reminder, index) in data.reminder" :key="index" class="greenChip mt-1"
                                                                                >{{reminder.number || "-"}}
                                                                                {{reminder.gap || "-"}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="event_data.all_events.length > 0">
                                                    <div class="mt-6 mb-4">
                                                        <span  style="font-weight: 600; font-size: 14px;">All Events</span>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-6 my-4" v-for="(data,index) in event_data.all_events"
                                                            :key="index">
                                                            <div class="dataTab d-flex flex-row align-items-center">
                                                                <div class="d-flex flex-column justify-content-center text-center px-3"
                                                                    style="height: 100%; border-right: 1px solid #cdd2da;">
                                                                    <div class="d-flex flex-column" style="width: 70px;">
                                                                        <span
                                                                            class="blueCalendarTop">{{moment(data.start_date).format('MMM') || "-" }}</span>
                                                                        <span
                                                                            class="blueCalendarBottom">{{moment(data.start_date).format('DD') || "-"}}</span>
                                                                    </div>
                                                                    <span class="mt-5 mb-1"
                                                                        style="color: #0d5be6; font-size: 14px; line-height: 14px;">{{moment(data.start_date).format('LLLL').split(',')[0] || "-"}}</span>
                                                                    <span
                                                                        style="color: #0d5be6; font-size: 10px; line-height: 10px;">{{data.start_time || "-"}}
                                                                        {{data.ampm}}</span>
                                                                </div>
                                                                <div class="d-flex flex-column mx-3 w-100" style="overflow: hidden;">
                                                                    <div class="d-flex align-items-center" style="justify-content: space-between">
                                                                        <!-- <img class="mr-2" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash.svg" style="height: 15px;" /> -->
                                                                        <el-tooltip class="item" effect="dark" :content="data.event_name"
                                                                            placement="top">
                                                                            <div class=""
                                                                                style="line-height: 20px; font-size: 15px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ data.event_name }}</div>
                                                                        </el-tooltip>
                                                                        <div v-if="$route.params.id == loggedInUser.user_id" class="d-flex align-items-center ml-auto">
                                                                            <i class="icon icon-delete text-blue pointer deleteIcon" style="font-size: 1.8rem;" @click="removeEvent('deleteEvent',data)"></i>
                                                                            <i class="icon icon-pencil text-blue pointer editIcon" @click="editEventById(data)" style="font-size: 1.8rem;"></i>
                                                                        </div>
                                                                    </div>
                                                                    <span class="mt-1"
                                                                        style="line-height: 20px; font-size: 13px;">{{ data.event_type }}</span>
                                                                    <el-dropdown trigger="click" :hide-on-click="true"
                                                                        style="width: 10em;">
                                                                        <span>
                                                                            <div class="d-flex align-items-center mt-1"
                                                                                style="line-height: 15px;">
                                                                                <div v-for="(item,index) in data.invitees"
                                                                                    :key="index">
                                                                                    <span v-if="index <= 2">
                                                                                        <img style="width: 15px;"
                                                                                            :src="item.profile_pic" />
                                                                                    </span>
                                                                                    <span v-if="index == 3"
                                                                                        style="line-height: 20px; font-size: 13px;">+{{data.invitees.length - 3}}</span>
                                                                                    <span v-else></span>
                                                                                </div>
                                                                            </div>
                                                                        </span>
                                                                        <el-dropdown-menu slot="dropdown"
                                                                            style="max-height: 10em; overflow-y: auto; border-radius: 0 !important; width: 12em;">
                                                                            <el-dropdown-item
                                                                                v-for="(item,index) in data.invitees"
                                                                                :key="index"
                                                                                class="d-flex align-items-center px-2">
                                                                                <img class="mr-2" style="width: 15px;"
                                                                                    :src="item.profile_pic" />{{item.full_name || "-"}}
                                                                            </el-dropdown-item>
                                                                        </el-dropdown-menu>
                                                                    </el-dropdown>
                                                                    <div class="d-flex">
                                                                        <span class="mt-1"
                                                                            style="line-height: 20px; font-size: 13px; width: 8em;">Remind
                                                                            Before : </span>
                                                                        <div class="d-flex flex-wrap">
                                                                            <div class="d-flex flex-wrap">
                                                                                <span v-for="(reminder, index) in data.reminder" :key="index" class="greenChip mt-1"
                                                                                    >{{reminder.number || "-"}}
                                                                                    {{reminder.gap || "-"}}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="d-flex align-items-center justify-content-center w-100 mt-5">
                                                    <span class="fw-600 fs-18">No Events Found!</span>
                                                </div>
                                            </div>
                                            <div v-else-if="event_data[Object.keys(event_data)[0]].length" class="row">
                                                <div class="col-6 my-4" v-for="(data, index) in event_data[Object.keys(event_data)[0]]" :key="index">
                                                    <div class="dataTab d-flex flex-row align-items-center">
                                                        <div class="d-flex flex-column justify-content-center text-center px-3"
                                                            style="height: 100%; border-right: 1px solid #cdd2da;">
                                                            <div class="d-flex flex-column" style="width: 70px;">
                                                                <span
                                                                    class="blueCalendarTop">{{moment(data.start_date).format('MMM') || "-" }}</span>
                                                                <span
                                                                    class="blueCalendarBottom">{{moment(data.start_date).format('DD') || "-"}}</span>
                                                            </div>
                                                            <span class="mt-5 mb-1"
                                                                style="color: #0d5be6; font-size: 14px; line-height: 14px;">{{moment(data.start_date).format('LLLL').split(',')[0] || "-"}}</span>
                                                            <span
                                                                style="color: #0d5be6; font-size: 10px; line-height: 10px;">{{data.start_time || "-"}}
                                                                {{data.ampm}}</span>
                                                        </div>
                                                        <div class="d-flex flex-column mx-3 w-100" style="overflow: hidden;">
                                                            <div class="d-flex align-items-center" style="justify-content: space-between">
                                                                <el-tooltip class="item" effect="dark" :content="data.event_name"
                                                                    placement="top">
                                                                    <div class=""
                                                                        style="line-height: 20px; font-size: 15px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ data.event_name }}</div>
                                                                </el-tooltip>
                                                                <div v-if="$route.params.id == loggedInUser.user_id" class="d-flex align-items-center ml-auto">
                                                                    <i class="icon icon-delete text-blue pointer deleteIcon" style="font-size: 1.8rem;" @click="removeEvent('deleteEvent',data)"></i>
                                                                    <i class="icon icon-pencil text-blue pointer editIcon" @click="editEventById(data)" style="font-size: 1.8rem;"></i>
                                                                </div>
                                                            </div>
                                                            <span class="mt-1"
                                                                style="line-height: 20px; font-size: 13px;">{{ data.event_type }}</span>
                                                            <el-dropdown trigger="click" :hide-on-click="true"
                                                                style="width: 10em;">
                                                                <span>
                                                                    <div class="d-flex align-items-center mt-1"
                                                                        style="line-height: 15px;">
                                                                        <div v-for="(item,index) in data.invitees"
                                                                            :key="index">
                                                                            <span v-if="index <= 2">
                                                                                <img style="width: 15px;"
                                                                                    :src="item.profile_pic" />
                                                                            </span>
                                                                            <span v-if="index == 3"
                                                                                style="line-height: 20px; font-size: 13px;">+{{data.invitees.length - 3}}</span>
                                                                            <span v-else></span>
                                                                        </div>
                                                                    </div>
                                                                </span>
                                                                <el-dropdown-menu slot="dropdown"
                                                                    style="max-height: 10em; overflow-y: auto; border-radius: 0 !important; width: 12em;">
                                                                    <el-dropdown-item
                                                                        v-for="(item,index) in data.invitees"
                                                                        :key="index"
                                                                        class="d-flex align-items-center px-2">
                                                                        <img class="mr-2" style="width: 15px;"
                                                                            :src="item.profile_pic" />{{item.full_name || "-"}}
                                                                    </el-dropdown-item>
                                                                </el-dropdown-menu>
                                                            </el-dropdown>
                                                            <div class="d-flex">
                                                                <span class="mt-1"
                                                                    style="line-height: 20px; font-size: 13px; width: 8em;">Remind
                                                                    Before : </span>
                                                                <div class="d-flex flex-wrap">
                                                                    <div class="d-flex flex-wrap">
                                                                        <span v-for="(reminder, index) in data.reminder" :key="index" class="greenChip mt-1"
                                                                            >{{reminder.number || "-"}}
                                                                            {{reminder.gap || "-"}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="d-flex align-items-center justify-content-center w-100 mt-5">
                                                <span class="fw-600 fs-18">No Events Found!</span>
                                            </div>
                                        </div>
                                        <div class="mt-5 mb-5 text-center w-100" v-if="loading_scroll_events"
                                            id="spinner_events">
                                            <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                        <div v-if="$route.params.id == loggedInUser.user_id" class="row w-100 align-items-center justify-content-end">
                                            <div class="">
                                                <span style="float:right;margin-right:10px;">
                                                    <button class="btn btn-secondary" @click="createEvent()">
                                                        + Create Event
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-10" v-if="toView === 'digiappsView' && !showAppNotifications">
                                        <div class="col-12">
                                            <span class="fw-600 fs-15 my-8">Click the highlighted notification count to
                                                get more details</span>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center w-100" v-if="!apps.length">
                                            <span class="fs-14 font-weight-bold">DigiApps not found</span>
                                        </div>
                                        <div v-else @scroll="infinite_scroll"
                                            style="overflow-x: hidden; height: 300px;width:100%;">
                                            <div class="row">
                                                <div class="col-6 mt-6" v-for="(app,index) in apps" :key="index">
                                                    <div class="d-flex align-items-center mt-6"
                                                        :class="index%2 == 0 ? 'mr-4' : 'ml-4'">
                                                        <div class="d-flex align-items-center justify-content-center"
                                                            style="box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41); border-radius: 6px 0px 0px 6px; height: 6em; width: 30%;">
                                                            <img :src="app.logo_blue" height="40" />
                                                        </div>
                                                        <div class="d-flex align-items-center px-4"
                                                            style="box-shadow: 1px 0 3px 0 rgba(0, 0, 0, 0.41); border-radius: 0px 6px 6px 0px; height: 6em; width: 70%;">
                                                            <span class="fw-600 fs-14"
                                                                style="color: #0d5be6;">{{ app.product_name }}</span>
                                                        </div>
                                                        <div v-if="app.count > 0" @click="getNotifications(app)"
                                                            class="d-flex align-items-center justify-content-center notificationNumber"
                                                            :style="index%2 == 0 ? 'right: 30px' : 'right: 15px'">
                                                            <span>{{ app.count }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-5 mb-5 text-center w-100" v-if="loading_scroll" id="spinner">
                                            <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                    </div>
                                    <div class="row mt-10" v-if="toView === 'digiappsView' && showAppNotifications">
                                        <div class="col-12">
                                            <div class="row d-flex align-items-center fw-600 fs-15 mb-4">
                                                <div class="col-3"></div>
                                                <div class="col-6 d-flex align-items-center justify-content-center">
                                                    <img class="mr-4" :src="notifications_data_logo" height="40" />
                                                    {{ notifications_data_prodname }}
                                                </div>
                                                <div class="col-3 d-flex align-items-center justify-content-end">
                                                    <button class="btn btn-new-primary btn-smm d-flex align-items-center" @click="showAppNotifications = false"><i class="icon-chevron-left"></i> Back</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-6">
                                            <div @scroll="infinite_scroll1" style="overflow-x: hidden; max-height: 300px; height: 100%;">
                                                <table class="table appNotificationsTable">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                TITLE
                                                            </th>
                                                            <th>
                                                                CREATED TIME
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr >
                                                            <td colspan="2">
                                                                <div class="d-flex align-items-center justify-content-center w-100" v-if="ajaxCallinprogress_notify && !notifications_data.length">
                                                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                                                </div>
                                                                <div class="d-flex align-items-center justify-content-center w-100" v-if="!ajaxCallinprogress_notify && !notifications_data.length">
                                                                    <span>No data found</span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-for="(notifications,index) in notifications_data" :key="index">
                                                            <td v-html="notifications.message" style="width: 70%;">

                                                            </td>
                                                            <td>
                                                                {{moment(notifications.created_date).format("DD/MM/YYYY")}}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-if="loading_scroll1" class="mt-5 mb-5" id="spinner1">
                                                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-event @hideCreateEvent="hideCreateEvent" @eventCreatedSuccess="eventCreatedSuccess" :edit_create="edit_create_text" :event_id="event_id" v-if="createevent" modal_name="create-event"></create-event>
        <add-birthday-popup v-if="is_add_new_birthday" modal_name="birthday-popup" @hideSelf="hideSelf" ></add-birthday-popup>
        <sweet-modal ref="success_modal" icon="success">Profile uploaded successfully</sweet-modal>
        <sweet-modal ref="delete_modal">Profile Deleted successfully</sweet-modal>
    </div>
</template>

<script>
    import moment from "moment";
    import profile from "./mixins/profile";
    import { SweetModal } from 'sweet-modal-vue';
    import CreateEvent from "./CreateEvent.vue";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import {
        EventBus
    } from './eventBus/nav-bar-event';
    const {
        uuid
    } = require('uuidv4');
    import axios from 'axios';
    import AddBirthdayPopup from './alertModals/AddBirthdayPopup.vue';
    export default {
        mixins: [profile],
        components: {
            HalfCircleSpinner,
            CreateEvent,
            SweetModal,
            AddBirthdayPopup
        },
        data() {
            return {
                toView: "birthdayView",
                createevent: false,
                adding_birthday: false,
                is_add_new_birthday: false,
                add_birthdays: [],
                edit_birthdays: [],
                edit_events: [],
                birthdays: [],
                events: [],
                apps: [],
                count_scroll: 0,
                loading_scroll: false,
                count_scroll1: 0,
                loading_scroll1: false,
                notifications_data: [],
                pickDate: false,
                dateRange: "",
                datePickShortcuts: [{
                        text: "Today",
                        onClick: () => this.shortcut("Today")
                    },
                    {
                        text: "This Week",
                        onClick: () => this.shortcut("This Week")
                    },
                    {
                        text: "This Month",
                        onClick: () => this.shortcut("This Month")
                    },
                    {
                        text: "This Year",
                        onClick: () => this.shortcut("This Year")
                    },
                ],
                relationship_options: [],
                dropdown_loading: false,
                selectedDate: new Date().getFullYear(),
                showAppNotifications: false,
                ajaxCallinprogress: false,
                ajaxCallinprogress_notify: false,
                notifications_data_prodname: '',
                notifications_data_logo: '',
                product_id: '',
                bottom: false,
                bottom1: false,
                edit_events_data: [],
                loading_scroll_birthdays: false,
                count_scroll_birthdays: 0,
                loading_scroll_events: false,
                count_scroll_events: 0,

                // new states
                // Birthdays
                edit_birthday_index: 0,
                skip: 0,
                edit_birthday: false,
                add_new_birthday: false,
                create_birthday: {
                    date_of_birth: "",
                    name: "",
                    profile_pic: "",
                    relationship: "",
                },
                edit_birthday_data: {
                    date_of_birth: "",
                    name: "",
                    profile_pic: "",
                    relationship: "",
                    id: ''
                },
                birthday_data: [],
                // Events
                event_skip: 0,
                event_data: {
                },
                start_date: '',
                end_date: '',
                event_between: '',
                filter_applied: false,
                edit_create_text: '',
                event_id: ''
            }
        },
        methods: {
            moment(date) {
                return moment(date);
            },
            goToSettings(){
                let reminders = true
                let routeData = this.$router.resolve({name: 'Settings', query: {reminders:reminders}});
                window.open(routeData.href, '_blank');
            },
            changeView(view) {
                this.toView = view;
                if (view === "digiappsView") {
                    this.$emit("showDigiApps");
                } else {
                    this.$emit("hideDigiApps");
                }
            },
            hideCreateEvent(){
                this.createevent = false;
                setTimeout(() => {
                    this.getAllEvents();
                }, 500);
            },
            createEvent(){
                this.createevent = true;
                this.edit_create_text = "CREATE";
                setTimeout(() => {
                    this.$modal.show('create-event')
                },500);
            },
            eventCreatedSuccess() {
                this.createevent = false;
                this.getAllEvents();
            },
            shortcut(type) {
                this.event_between = type;
                switch (type) {
                    case "Today":
                        this.dateRange = [new Date(), new Date()];
                        this.selectedDate = "Today's Events";
                        this.getEventsFiltered("from_shortcuts");
                        break;
                    case "This Week":
                        let startDateWeek = new Date().getDate() - new Date().getDay();
                        let lastDateWeek = startDateWeek + 6;
                        this.dateRange = [new Date(new Date().setDate(startDateWeek)), new Date(new Date().setDate(
                            lastDateWeek))];
                        this.selectedDate = "This Week's Events";
                        this.getEventsFiltered("from_shortcuts");
                        break;
                    case "This Month":
                        let startDateMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                        let lastDateMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
                        this.dateRange = [startDateMonth, lastDateMonth];
                        this.selectedDate = "This Month's Events";
                        this.getEventsFiltered("from_shortcuts");
                        break;
                    case "This Year":
                        let startDateYear = new Date(new Date().getFullYear(), 0, 1);
                        let lastDateYear = new Date(new Date().getFullYear(), 11, 31);
                        this.dateRange = [startDateYear, lastDateYear];
                        this.selectedDate = new Date().getFullYear();
                        this.getEventsFiltered("from_shortcuts");
                        break;
                    default:
                        break;
                }
            },
            editBirthday(data, index) {
                this.edit_birthday_data.name = data.name;
                this.edit_birthday_data.relationship = data.relationship;
                this.edit_birthday_data.profile_pic = data.profile_pic;
                this.edit_birthday_data.date_of_birth = data.date_of_birth;
                this.edit_birthday_data.id = data.id;
                this.edit_birthday_index = index;
                this.edit_birthday = true;
            },
            resetDate() {
                this.dateRange = "";
                // this.selectedDate = new Date().getFullYear();
                this.start_date = '';
                this.end_date = '';
                this.event_between = '';
                this.getAllEvents();
            },
            async removeEvent(type, selectedEvent) {
                try {
                    let id = selectedEvent.id;
                    let response = await this.deleteEvents(id);
                    if(response.status_id == 1) {
                        this.getAllEvents();
                    }
                }
                catch(err) {
                    // console.log(err);
                }
            },
            addBirthday() {
                if(this.add_new_birthday == true || this.edit_birthday == true) {
                    this.is_add_new_birthday = true;
                    setTimeout(() => {
                        this.$modal.show('birthday-popup');
                    }, 500);
                } else {
                    this.add_new_birthday = true;
                    this.adding_birthday = true;
                    this.create_birthday = {
                        date_of_birth: "",
                        name: "",
                        profile_pic: "",
                        relationship: "",
                    };
                }
            },
            hideSelf() {
                this.is_add_new_birthday = false;
            },
            closeAddDialogBox() {
                this.add_new_birthday = false;
                this.adding_birthday = false;
                this.create_birthday = {
                    date_of_birth: "",
                    name: "",
                    profile_pic: "",
                    relationship: "",
                };
            },

            closeEditDialogBox(){
                this.edit_birthday = false;
            },

            async DeleteAll() {
                try {
                    let param = {
                        id: []
                    }
                    this.birthday_data.forEach(el=>{
                        param.id.push(el.id);
                    });
                    let response = await this.deleteBirthdayMultiple(param);
                    if(response.status_id == 1) {
                        this.getBirthdays()
                    }
                }
                catch(err) {

                }
            },

            applyBirthdayRem(field_common_id, field_profile_pic, field_name, field_date_of_birth, field_relationship) {
                this.birthdays.push({
                    common_id: field_common_id,
                    profile_pic: field_profile_pic,
                    name: field_name,
                    date_of_birth: field_date_of_birth,
                    relationship: field_relationship,
                })
                this.add_birthdays = []
            },

            ApplyEditedBirthdayEvent(edited_id, edited_profile_pic, edited_name, edited_date_of_birth,
                edited_relationship) {
                this.birthdays.forEach((birthdayEvent) => {
                    if (birthdayEvent.common_id === edited_id) {
                        birthdayEvent.profile_pic = edited_profile_pic
                        birthdayEvent.name = edited_name
                        birthdayEvent.date_of_birth = edited_date_of_birth
                        birthdayEvent.relationship = edited_relationship
                    }
                })
                this.edit_birthdays = []
            },

            async infiniteScrollBirthdays(e) {
                const {
                    target
                } = e;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                    try {
                        this.loading_scroll_birthdays = true
                        let params = {
                            skip: this.count_scroll_birthdays,
                            search_key: "",
                            limit: 10,
                        }
                        let res = await this.$http.post("/events/birthday/list", params)
                        if (res.data.skip == this.count_scroll_birthdays) {
                            let tempFiles = res.data.response
                            tempFiles.forEach(el => {
                                this.birthdays.push(el)
                            })
                            this.birthdays = this.birthdays.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.birthdays.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.count_scroll_birthdays += res.data.response.length
                            this.loading_scroll_birthdays = false
                        }
                        if (res.data.response.length < 10) {
                            document.getElementById('spinner_birthdays').style.display = 'none'
                            this.loading_scroll_birthdays = false
                        }
                    } catch (reason) {

                    }

                }
            },
            async getEventsFiltered(from_shortcuts) {
                if (!from_shortcuts) {
                    this.start_date = moment(new Date(new Date(this.dateRange[0]).getTime() + 1000 * 60 * 60 * 24)).format().split(' ')[0]+'Z';
                    this.end_date = moment(new Date(new Date(this.dateRange[1]).getTime() + 1000 * 60 * 60 * 24)).format().split(' ')[0]+'Z';
                } else {
                    this.start_date = moment(this.dateRange[0]).format().split(' ')[0]+'Z';
                    this.end_date = moment(this.dateRange[0]).format().split(' ')[0]+'Z';
                }
                this.filter_applied = true;
                this.getAllEvents();
            },
            async infiniteScrollEvents(e) {
                const {
                    target
                } = e;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                    try {
                        this.loading_scroll_events = true
                        let params = {
                            skip: this.count_scroll_events,
                            search_key: "",
                            limit: 10,
                        }
                        let res = await this.$http.post("/events/list", params)
                        if (res.data.skip == this.count_scroll_events) {
                            let tempFiles = res.data.response
                            tempFiles.forEach(el => {
                                this.events.push(el)
                            })
                            this.events.forEach(x => {
                                if ("start_date_time" in x) {
                                    if (x.start_date_time.date && x.start_date_time.time) {
                                        let startDate = x.start_date_time.date;
                                        let pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                                        let formattedDate = new Date(startDate.replace(pattern,
                                        '$3-$2-$1'));
                                        let date = startDate.split("/");
                                        let time = x.start_date_time.time.split(":");
                                        Object.assign(x.start_date_time, {
                                            month: formattedDate.toLocaleString('default', {
                                                month: 'short'
                                            }),
                                            dateNum: date[0],
                                            day: formattedDate.toLocaleString('default', {
                                                weekday: 'long'
                                            }),
                                            ampm: time[0] >= 12 ? "pm" : "am",
                                        });
                                    }
                                }
                                if (!"event_schedule" in x) {
                                    Object.assign(this.events, {
                                        event_schedule: {
                                            start_date: "",
                                            end_date: "",
                                            all_day: false,
                                        }
                                    });
                                }
                                if (x.event_schedule && x.event_schedule == {}) {
                                    x.event_schedule = {
                                        start_date: "",
                                        end_date: "",
                                        all_day: false,
                                    }
                                }
                                if (!"repeat_cycle" in x) {
                                    Object.assign(this.events, {
                                        repeat_cycle: {
                                            start: "",
                                            end: "",
                                            cycle: {
                                                number: 0,
                                                gap: "",
                                            }
                                        }
                                    });
                                }
                                if (x.repeat_cycle && x.repeat_cycle == {}) {
                                    x.repeat_cycle = {
                                        start: "",
                                        end: "",
                                        cycle: {
                                            number: 0,
                                            gap: "",
                                        }
                                    }
                                }
                                if (!"remind_before" in x) {
                                    Object.assign(this.events, {
                                        remind_before: [{
                                            number: 0,
                                            gap: "",
                                        }]
                                    });
                                }
                                if (x.remind_before && x.remind_before.length === 0) {
                                    x.remind_before.push({
                                        number: 0,
                                        gap: "",
                                    });
                                }
                            });
                            this.events = this.events.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.events.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.count_scroll_events += res.data.response.length
                            this.loading_scroll_events = false
                        }
                        if (res.data.response.length < 10) {
                            document.getElementById('spinner_events').style.display = 'none'
                            this.loading_scroll_events = false
                        }
                    } catch (reason) {

                    }

                }
            },
            async getNotifications(data) {
                this.product_id = data._id;
                this.showAppNotifications = true;
                this.ajaxCallinprogress_notify = true;
                this.notifications_data_prodname = data.product_name;
                this.notifications_data_logo = data.logo_blue;
                try {
                    let params = {
                        limit: 10,
                        skip: 0,
                        product_id: this.product_id
                    }
                    let res = await this.$http.post('/notifications/list', params);
                    if (res.data.status_id === 1) {
                        this.notifications_data = res.data.response;
                        this.count_scroll1 = res.data.response.length;
                    }
                    this.ajaxCallinprogress_notify = false;
                } catch (error) {

                }
            },
            async getDigiApps() {
                try {
                    let params = {
                        limit: 10,
                        skip: 0
                    }
                    let res = await this.$http.post('/user_products/digi_apps', params);
                    if (res.data.status_id === 1) {
                        this.apps = res.data.response;
                        this.count_scroll = res.data.response.length;
                    }
                } catch (err) {

                }
            },
            async infinite_scroll(e) {
                const {
                    target
                } = e;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                    //this code will run when the user scrolls to the bottom of this div so
                    //you could do an api call here to implement lazy loading
                    try {
                        this.loading_scroll = true
                        let params = {
                            skip: this.count_scroll,
                            limit: 10,
                        }
                        let res = await this.$http.post('/user_products/digi_apps', params)
                        if (res.data.skip == this.count_scroll) {
                            let tempFiles = res.data.response
                            tempFiles.forEach(el => {
                                this.apps.push(el)
                            })
                            this.apps = this.apps.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.apps.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.count_scroll += res.data.response.length
                            this.loading_scroll = false
                        }
                        if (res.data.response.length < 10) {
                            document.getElementById('spinner').style.display = 'none'
                            this.loading_scroll = false
                        }
                    } catch (reason) {

                    }
                    this.bottom = true;

                }
            },
            async infinite_scroll1(e) {
                const {
                    target
                } = e;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                    //this code will run when the user scrolls to the bottom of this div so
                    //you could do an api call here to implement lazy loading
                    try {
                        this.loading_scroll1 = true
                        let params = {
                            skip: this.count_scroll1,
                            limit: 10,
                            product_id: this.product_id
                        }
                        let res = await this.$http.post('/notifications/list', params)
                        if (res.data.skip == this.count_scroll1) {
                            let tempFiles = res.data.response
                            tempFiles.forEach(el => {
                                this.notifications_data.push(el)
                            })
                            this.notifications_data = this.notifications_data.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.notifications_data.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.count_scroll1 += res.data.response.length
                            this.loading_scroll1 = false
                        }
                        if (res.data.response.length < 10) {
                            document.getElementById('spinner1').style.display = 'none'
                            this.loading_scroll1 = false
                        }
                    } catch (reason) {

                    }
                    this.bottom1 = true;

                }
            },



            uploadAttachment(e) {
                var input = e.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: "",
                    };
                    this.getResumableURL(input.files[0], attachment);
                }
            },
            getResumableURL(file, attachment) {
                let vuethis = this;
                let data = {
                    file: attachment.name,
                };
                data = new FormData();
                data.append("file", file);
                this.$http.post("https://cloudapis.digicollect.com/external/upload_file", data).then(response => {
                    this.$refs.success_modal.open();;
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        // this.hideSelf();
                        this.create_birthday.profile_pic = response.data.url;
                        this.edit_birthday_data.profile_pic = response.data.url;
                        // this.$emit("uploaded", response.data.url)
                    }, 2000);
                }).catch(error => {
                    // console.log(error.data.reason);
                });
            },
            deletePic() {
                try {
                    this.$swal({
                        title: 'Alert',
                        text: "Are you sure want to delete ?",
                        type: 'warning',
                        icon: 'warning',
                        showCloseButton: true,
                        showCancelButton: true,
                        confirmButtonText:'YES',
                        cancelButtonText:'NO'
                    }).then((result) => {
                        if (result.value) {
                            this.$refs.delete_modal.open();;
                            setTimeout(() => {
                                this.$refs.delete_modal.close();
                                // this.hideSelf();
                                // this.$emit("deletePic");
                                this.create_birthday.profile_pic = 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png';
                            }, 2000);
                        }
                    })
                } catch (reason) {
                    // console.log(reason)
                }
            },

            // Birthday's Api call methods
            async getBirthdays() {
                this.ajaxCallinprogress = true;
                try {
                    let skip = this.skip;
                    let response = await this.getBirthdayList(skip);
                    if(response.status_id == 1) {
                        this.birthday_data = response.response;
                    }
                    this.ajaxCallinprogress = false;
                }
                catch(err) {
                    // console.log(err);
                }
            },
            async createNewBirthday() {
                this.$validator.validateAll().then(async result => {
                    if (result && this.create_birthday.date_of_birth != '') {
                        try {
                            let params = {
                                name: this.create_birthday.name,
                                relationship: this.create_birthday.relationship,
                                date_of_birth: this.create_birthday.date_of_birth ? this.create_birthday.date_of_birth : '',
                                profile_pic: this.create_birthday.profile_pic
                            };
                            let response = await this.createBirthday(params);
                            if(response.status_id == 1) {
                                this.add_new_birthday = false;
                                this.getBirthdays();
                            }
                        }
                        catch(err) {
                            // console.log(err);
                        }
                    }
                });
            },
            submitNewBirthday() {
                this.createNewBirthday();
            },
            async editBirthdaySubmit() {
                this.$validator.validateAll().then(async result => {
                    if (result && this.edit_birthday_data.date_of_birth != '') {
                        try {
                            let param = {
                                name: this.edit_birthday_data.name,
                                relationship: this.edit_birthday_data.relationship,
                                date_of_birth: this.edit_birthday_data.date_of_birth,
                                profile_pic: this.edit_birthday_data.profile_pic,
                            }
                            if(this.edit_birthday_data.id) {
                                param.id = this.edit_birthday_data.id;
                            }
                            let response = await this.updateBirthday(param, this.edit_birthday_data.id);
                            if(response.status_id == 1) {
                                this.edit_birthday = false;
                                this.getBirthdays();
                            }
                        }
                        catch(err) {
                            // console.log(err);
                        }
                    }
                });
            },
            async deleteBirthdayById(id) {
                try {
                    let param = id;
                    let response = await this.deleteBirthday(param);
                    if(response.status_id == 1) {
                        this.getBirthdays();
                    }
                }
                catch(err) {
                    // console.log(err);
                }
            },
            // Event's Api call methods
            async getAllEvents() {
                this.ajaxCallinprogress = true;
                try {
                    let param = {
                        skip: this.event_skip,
                        limit: 10,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        event_between: this.event_between
                    };
                    let response = await this.getEventsList(param);
                    if(response.status_id == 1) {
                        let events_data = response.response;
                        this.event_data = events_data;
                    }
                    this.ajaxCallinprogress = false;
                }
                catch(err) {
                    // console.log(err);
                }
            },
            editEventById(data) {
                this.event_id = data.id;
                this.createevent = true;
                this.edit_create_text = "EDIT";
                setTimeout(() => {
                    this.$modal.show('create-event')
                },500);
            },
            async dropdownsData(type) {
                if(type == 'relationship') {
                    this.edit_room_type = true;
                }
                this.dropdown_loading = true;
                try {
                    let params = type;
                    let response = await this.getDropdownsData(params);
                    if(response.status_id == 1) {
                        if(type == 'relationship') {
                            this.relationship_options = response.response;
                        }
                    }
                    this.dropdown_loading = false;
                }
                catch(err) {
                    // console.log(err);
                }
            }
        },
        mounted() {
            this.getBirthdays();
            this.getAllEvents();
            this.getDigiApps();
        },
        created() {
            const dict = {
                custom: {
                    add_name:{
                        required: () => "Please enter Name",
                    },
                    edit_name:{
                        required: () => "Please enter Name",
                    },
                    date_of_birth: {
                        required: () => "Please select Date of Birth"
                    }
                }
            };
            this.$validator.localize("en", dict);
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            // account() {
            //     return this.$store.getters.account;
            // },
            // selectedCompany() {
            //     return this.$store.getters.selectedCompany;
            // },
        },
    }
</script>

<style scoped>
    .top-tabs-reminders {
        border: 1px solid #707070;
        border-radius: 8px;
        background: transparent;
        color: #3f3f3f !important;
        font-size: 15px;
        cursor: pointer;
        width: 100%;
    }

    .top-tabs-reminders:hover {
        border: 1px solid #005dae;
        background: #005dae;
        color: #ffffff !important;
    }

    .active {
        border: 1px solid #005dae;
        background: #005dae;
        color: #ffffff !important;
    }

    .dataTab {
        /* border: 1px solid #707070; */
        border-radius: 6px;
        color: #3f3f3f;
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41);
        height: 10em;
        margin-left: 8px;
        margin-right: 8px;
    }

    .dataTab1 {
        /* border: 1px solid #707070; */
        border-radius: 6px;
        color: #3f3f3f;
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41);
        /* height: 25em; */
        margin-left: 8px;
        margin-right: 8px;
    }

    .greenChip {
        background: rgb(18, 136, 7) none repeat scroll 0% 0%;
        color: rgb(255, 255, 255);
        border-radius: 20px;
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        text-align: center;
        width: 5.2em;
        margin-right: 5px;
    }

    .blueCalendarTop {
        background: #0d5be6;
        color: #fff;
        font-weight: 600;
        border: 3px solid #abc1e5;
        border-radius: 5px 5px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 2em;
    }

    .blueCalendarBottom {
        background: #0d5be6;
        color: #fff;
        font-weight: 800;
        border: 3px solid #abc1e5;
        border-radius: 0px 0px 5px 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 2.3em;
        font-size: 15px;
        border-top: 0;
    }

    .notificationNumber {
        position: absolute;
        top: 8px;
        font-size: 18px;
        background: #f5a623;
        border-radius: 50%;
        padding: 10px;
        height: 30px;
        width: 30px;
        cursor: pointer;
    }

    .appNotificationsTable thead tr th {
        background: #005dae;
        color: #ffffff;
        font-weight: 600;
        font-size: 14px;
        padding: 0rem 4rem !important;
    }

    .appNotificationsTable tbody tr td {
        color: #000000;
        font-size: 12px;
        padding: 1rem 4rem !important;
    }

    .appNotificationsTable tbody tr {
        box-shadow: 0 0.5px 1px 0 rgba(0, 0, 0, 0.16);
    }

    .inputField1 {
        border: 1px solid black;
        width: 100% !important;
        border-radius: 5px;
    }

    .label {
        margin-bottom: 0px
    }
</style>


// WEBPACK FOOTER //
// src/components/RemindersView.vue